import { GEARBOX_MODEL_DATA, MANUAL_DATA,ELECTRICAL_DATA ,YOKE_DATA} from "../actions/Types";

const initialState = {
    gearBoxModelData: [],
    manualSectionData: {},
    electricSectionData : {},
    yokeSectionData  :{}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GEARBOX_MODEL_DATA:
            return {
                ...state,
                gearBoxModelData: true
            };
        case MANUAL_DATA:
            return {
                ...state,
                manualSectionData: action.payload
            };
            case ELECTRICAL_DATA:
            return {
                ...state,
                electricSectionData: action.payload
            };
            case YOKE_DATA:
                return {
                    ...state,
                    yokeSectionData: action.payload
                };
        default:
            return state;
    }
}
